import { render, staticRenderFns } from "./financial_details.vue?vue&type=template&id=688d33f2&scoped=true"
import script from "./financial_details.vue?vue&type=script&lang=js"
export * from "./financial_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d33f2",
  null
  
)

export default component.exports